export default __webpack_public_path__ + "static/tommy@2x-bb4aaed3cc5ae1f3d8ce1e84aa688c4e.png";